module.exports = __webpack_public_path__ + "img/icons8-project-setup-100_1_75.f0055aba.png";